export default {
    "promptToRetranslate" : false,
    "thumbnailUrl" : "https://cc-converter-test.s3.us-east-2.amazonaws.com/No+Media.png",
    "mediaUrl" : "https://cc-converter-test.s3.us-east-2.amazonaws.com/trailer.mp4",
    "mediaType" : "mp4",
    "aspectRatio" : "16:9",
    "captionTracks" : [
        {
            "language" : "en-US",
            "url" : "https://firebasestorage.googleapis.com/v0/b/closed-caption-creator-app.appspot.com/o/content%2Fsubtitles%2Faws-example-longer.json.ccprj?alt=media&token=1e041248-8bf2-4162-9ebb-f4cd7e3c6aec",
            "type" : "closedCaptionProject",
            "maxChars" : 32,
            "maxLines" : 2,
            "overlaps" : true, 
            "illegalChars" : true
        }
    ],
    "captionType" : "scenerist",
    "publishEndpoint" : "/cablecastapi/v1/blahblah",
    "projectName" : "Trailer Test",
    "frameRate" : 29.97,
    "dropFrame" : true,
    "styleGuides" : [
        {
            "name" : "Example Name",
            "minDuration" : 0.001,
            "maxDuration" : 6,
            "maxChars" : 32,
            "maxLines" : 2,
            "overlaps" : true,
            "illegalChars" : true
        }
    ]
};